import { Cart } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import { getAttributeTextValueByName } from './attributes-helpers';
import { MTT_ZONE_AFFILIATION_ID_TRANSACTION_ATTRIBUTE } from '../constants';

export const getCurrentZoneAffiliationId = (cart: Cart): number => {
    return (
        parseInt(getAttributeTextValueByName(cart?.AttributeValues ?? [], MTT_ZONE_AFFILIATION_ID_TRANSACTION_ATTRIBUTE) ?? '0', 10) || 0
    );
};
